// ********************************************************************************************************************
// 后台管理主页
const Background = () => import('views/bg/Background')

// 后台管理
const AdminApproval = () => import('views/bg/aaa/AdminApproval')
const AdminAccountList = () => import('views/bg/aaa/AdminAccountList')
const AdminAccountOnline = () => import('views/bg/aaa/AdminAccountOnline')
const AdminVideoList = () => import('views/bg/aaa/AdminVideoList')

export default {
  path: '/bg/admin',
  redirect: '/bg',
  name: 'Admin',
  title: '后台管理',
  icon: 'el-icon-edit',
  component: Background,
  meta: { needAuth: true, roles: ['tnb_admin'] },
  children: [
    {
      path: '/bg/admin/approval',
      name: 'AdminApproval',
      title: '审批',
      icon: 'el-icon-edit',
      component: AdminApproval,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/admin/account_online',
      name: 'AdminAccountOnline',
      title: '在线账号',
      icon: 'el-icon-edit',
      component: AdminAccountOnline,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/admin/account_list',
      name: 'AdminAccountList',
      title: '账号列表',
      icon: 'el-icon-edit',
      component: AdminAccountList,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    },
    {
      path: '/bg/admin/video',
      name: 'AdminVideoList',
      title: '视频管理',
      icon: 'el-icon-edit',
      component: AdminVideoList,
      meta: { needAuth: true, roles: ['tnb_admin'] }
    }
  ]
}
